module.exports = __webpack_public_path__ + "img/sunflower_half.5b1cdee4.svg";